import React from 'react';
import UseFixedAssetDepreciationMethodStatusGrid from './hooks/useFixedAssetDepreciationMethodStatusGrid';
import { ColDef } from 'ag-grid-community';
import BaseFormGrid from '../../components/grids/BaseFormGrid';
import DefaultColumnTypes from '../../components/grids/columns/Column.constants';
import { cloneDeep } from 'lodash';

const FixedAssetDepreciationMethodStatusGrid = () => {
    const {
        statusList,
        redirectToForm,
        isLoadingStatuses,
        canCreateDepreciationMethodStatus,
        canViewDepreciationMethodStatus,
        handleGridEdits,
    } = UseFixedAssetDepreciationMethodStatusGrid();

    const statusColumnDefs: ColDef[] = [
        {
            field: 'code',
            headerName: 'Code',
            ...DefaultColumnTypes.ShortText,
        },
        {
            field: 'description',
            headerName: 'Description',
            ...DefaultColumnTypes.LongText,
        },
        {
            field: 'isActive',
            headerName: 'Active',
            ...DefaultColumnTypes.Boolean,
        },
    ];

    return (
        <BaseFormGrid
            title="Depreciation Method Statuses"
            displayGrid={canViewDepreciationMethodStatus}
            isLoading={isLoadingStatuses}
            rowData={cloneDeep(statusList)}
            useRowDrag={true}
            sortKey={'sortOrder'}
            columnDefs={statusColumnDefs}
            gridClass="full-size-item"
            displayToolbar={true}
            displayCreateNewButton={canCreateDepreciationMethodStatus}
            displayExportDataButton={true}
            displayResetStateButton={true}
            onCreateNew={redirectToForm}
            onRowClicked={({ data }) => redirectToForm(data)}
            onHandleGridEdits={handleGridEdits}
        />
    );
};

export default FixedAssetDepreciationMethodStatusGrid;
